import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "Stores",
    components: {
        FormModal,
        Loading,
        BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
    },
    directives: {
        'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            items:[],
            mode: 'create',
            createRules:[],
            editRules:[],
            url: 'admin/stores',
            fields: [{
                key: 'index',
                label: 'ردیف'
            },
                {
                    key: 'id',
                    label: 'شناسه'
                },
                {
                    key: 'label',
                    label: 'نام انبار'
                },
                {
                    key: 'is_main',
                    label: 'انبار اصلی'
                },
                {
                    key: 'created_at',
                    label: 'تاریخ ثبت'
                },
                {
                    key: 'operation',
                    label: 'عملیات'
                },
            ],
            filter: {
            },
            status_options: [{
                    name: 'فعال',
                    value: '1'
                },
                {
                    name: 'غیرفعال',
                    value: '0'
                },
                {
                    name: 'همه',
                    value: ''
                },
            ],
        }
    },
    mounted() {
        this.loadStores()
    },
    methods: {
        async loadStores(){
            try {
                const response = await this.$axios.get("admin/stores");
                this.items = Object.values(response.data.data.stores);
                this.createRules = response.data.data.store_rules;
                this.editRules = response.data.data.update_rules;
            } catch (e) {
                this.$root.notify(e);
            } 
        },
        deleteItem(id) {
            window.swal({
                title: "آیتم حذف شود؟",
                text: "این عملیات غیر قابل بازگشت خواهد بود",
                icon: "warning",
        
                showCancelButton: true,
                showConfirmButton: true,
                dangerMode: true,
                buttons: ["خیر", "بله حذف کن"]
            })
            .then((willDelete) => {
                if (willDelete) {
                this.$axios.delete(`admin/stores/${id}`)
                    .then((response) => {
                        this.items = this.items.filter(item => item.id != id)
                        window.swal({
                        icon: "success",
                        showConfirmButton: true,
                        text: response.data.message,
                        button: "باشه",
                        })
                    })
                    .catch(error => {
                        window.swal({
                        title: 'خطا',
                        showConfirmButton: true,
                        text: error.response.data.message,
                        button: "باشه",
                        })
                    })
                }
            })
            .catch(() => {
            })
        },
        editItem(index) {
            if (!(this.edit && this.edit._index === index) || this.mode !== 'edit') {
                let item;
                item = window.clone(this.items[index])
                item._index = index
                this.edit = item
                this.mode = 'edit'
            }
            this.$root.$emit('bv::show::modal', 'modal-' + this.$options.name)
        },
        async onCreate(data) {
            let objectKey = Object.keys(data.data)[0]
            this.items.unshift(data.data[objectKey]);
            const response = await this.$axios.get("admin/stores");
            this.items = Object.values(response.data.data.stores);
        },
        async onEdit(data, index) {
            let objectKey = Object.keys(data.data)[0]
            let model = data.data[objectKey];
            this.$root.$set(this.items, index, model);
            const response = await this.$axios.get("admin/stores");
            this.items = Object.values(response.data.data.stores);
        },
    }
}
